import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import SideBar4 from '../../components/Sidebar/SideBar4';
import { Card } from 'antd';
import useFetchCauseCategories from '../../hooks/fetchCauseCategories';
import { message, Upload, Switch, Select, DatePicker, Form, Input } from 'antd';
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import useFetchOrganizations from '../../hooks/fetchOrganizations';
import {app} from '../../config';
import useFetchStates from '../../hooks/fetchStates';
import useFetchCountries from '../../hooks/fetchCountries';

const { TextArea } = Input;
const AddCity = () => {
  const { t } = useTranslation(['common']);
  let navigate = useNavigate();
  const getBase64 = (img, callback) => {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
  };
  const [loading, setLoading] = useState(false);
  const [imageUrl, setImageUrl] = useState();
  const [causeObj, setCauseObj] = useState({
    causeCategory: '',
    isActive: ''
  });
  let user = JSON.parse(localStorage.getItem('user'));
  
  const handleChange = (info) => {
    if (info.file.status === 'uploading') {
      setLoading(true);
      return;
    }
    if (info.file.status === 'done') {
      // Get this url from response in real world.
      getBase64(info.file.originFileObj, (url) => {
        setLoading(false);
        setImageUrl(url);
      });
    }
  };
  const beforeUpload = (file) => {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng) {
      message.error('You can only upload JPG/PNG file!');
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      message.error('Image must smaller than 2MB!');
    }
    return isJpgOrPng && isLt2M;
  };
  const uploadButton = (
    <div>
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div
        style={{
          marginTop: 8,
        }}
      >
        Upload
      </div>
    </div>
  );
  // console.log(causeCat[0].cause_category);
const s=useFetchStates();
const states=s.response?s.response.data:[];
const c=useFetchCountries();
const countries=c.response?c.response.data:[];
console.log(countries);
  const uploadData=async(uploadObj)=>{
    try {
      console.log(uploadObj);
      const res = await axios.post(`${app.URL}/city/add`, uploadObj);
      console.log(res);
      window.alert(res.data.message);
      if (res.data.statusCode===200) navigate('/city/view');
    } catch (err) {
      console.log("Error");
      console.log(err);
      // if (err) window.alert(err.response.data.data.message);
      // else retrun;
    }
  }
  const onFinish = (values) => {
    console.log('Success:', values);
    // o={...values}
    // console.log(values.validityDate.format().split('T')[0]);
    setCauseObj({
      name: values.name ? values.name : '',
      stateId: values.stateId ? values.stateId : '',
      countryId:values.countryId? values.countryId : '',
      isActive: values.isActive === true ? 1 : 0,
      createdByUserId:user.userId
    });
  };
  console.log(causeObj);
  if(Object.keys(causeObj).length>0)uploadData(causeObj);
  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };
  const renderList = []; //For testing purposes
  return (
    <div className='col-lg-9 mt-4 tbl p-4'>
        <div className='fs-3 text-center mb-4 fw-bold'>{t('Add City')}</div>
        <Form
                name='basic'
                labelCol={{
                  span: 8,
                }}
                wrapperCol={{
                  span: 16,
                }}
                style={{
                  maxWidth: 600,
                }}
                initialValues={{
                  remember: true,
                  // ['id']: 1,
                  // ['causename']: 'Hammad',
                  // ['causeCategory']:'test', 
                  // ['isActive']: true,
                }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete='off'
              >
                <Form.Item  
                  colon={false}
                  label='City Name'
                  name='name'
                  rules={[
                    {
                      required: true,
                      message: 'Please input your username!',
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  label='State'
                  name='stateId'
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <Select
                    listHeight={250}
                    listItemHeight={500}
                    placeholder="Select"
                    style={{
                      width: 160,
                    }}
                  >
                    {states.map((state) => {
                      return (
                        <Option key={state.stateId} value={state.stateId}>
                          {state.name}
                        </Option>
                      );
                    })}
                  </Select>
                </Form.Item>
                <Form.Item
                  label='Country'
                  name='countryId'
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <Select
                    listHeight={250}
                    listItemHeight={500}
                    placeholder="Select"
                    style={{
                      width: 160,
                    }}
                  >
                    {countries.map((country) => {
                      return (
                        <Option key={country.countryId} value={country.countryId}>
                          {country.name}
                        </Option>
                      );
                    })}
                  </Select>
                </Form.Item>
                {/* <Form.Item label='Image' name='image'>
                  <Upload
                    // name="avatar"
                    listType='picture-card'
                    className='avatar-uploader'
                    showUploadList={false}
                    action='https://www.mocky.io/v2/5cc8019d300000980a055e76'
                    beforeUpload={beforeUpload}
                    onChange={handleChange}
                  >
                    {imageUrl ? (
                      <img
                        src={imageUrl}
                        alt='avatar'
                        style={{
                          width: '100%',
                        }}
                      />
                    ) : (
                      uploadButton
                    )}
                  </Upload>
                </Form.Item> */}

                <Form.Item label='Active' valuePropName='checked'  colon={false} name='isActive'>
                  <Switch />
                </Form.Item>
                <Form.Item
                  wrapperCol={{
                    offset: 8,
                    span: 16,
                  }}
                  colon={false}
                >
                  <button type='primary' class='btn btn-primary button' htmlType='submit'>
                    Submit
                  </button>
                </Form.Item>
              </Form>
        </div>
    // </div>
  );
};

export default AddCity;
